
export const menus = [
    {name: "Header meni", value: 1},
    {name: "FAQ meni", value: 2}
];

export const maxDepth = 1;